import request from "@/utils/request";

//公共产品分页查询
export function materialList(data) {
    return request({
        url: `productLibrary/web/productLibrary/materialList`,
        method: "get",
        params: data,
    });
}
//工艺控制
export function productCraftList(data) {
    return request({
        url: `productCraft/web/productCraftList`,
        method: "get",
        params: data,
    });
}

export function productLibraryDetails(data) {
    return request({
        url: `productLibrary/web/productLibrary/details`,
        method: "get",
        params: data,
    });
}

export function informationOperation(data) {
  return request({
    url: `userInformation/informationOperation`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}
